import type { CstElement, CstNode, IToken } from 'chevrotain';
import { isIToken } from 'millan';

export class ChainableCst<CstType> {
  Cst: new (cstNode: CstNode | undefined) => CstType;

  namespaces: Record<string, string>;

  visitedTokens: Set<number>;

  constructor(
    chainableCst: new (cstNode: CstNode | undefined) => CstType,
    namespaces: Record<string, string>
  ) {
    this.Cst = chainableCst;
    this.namespaces = namespaces;
    this.visitedTokens = new Set();
  }

  newChainableCst(cstNode: CstNode | undefined) {
    return new this.Cst(cstNode);
  }

  processTokens(...tokens: Array<IToken | undefined>) {
    tokens.forEach((token) => {
      if (token) {
        this.visitedTokens.add(token.startOffset);
      }
    });
    return this;
  }

  getTokens(cstNode: CstNode | undefined) {
    const allTokens = new Set<IToken>();
    const unprocessedTokens = new Set<IToken>();
    const processElement = (cstElement: CstElement | undefined) => {
      // istanbul ignore if
      if (!cstElement) {
        return;
      }

      if (isIToken(cstElement)) {
        allTokens.add(cstElement);
        if (!this.visitedTokens.has(cstElement.startOffset)) {
          unprocessedTokens.add(cstElement);
        }
      } else {
        Object.values(cstElement.children).forEach((children) => {
          children.forEach((child) => processElement(child));
        });
      }
    };
    processElement(cstNode);
    return { allTokens, unprocessedTokens };
  }
}
